import React, { useEffect, useMemo, useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import type { CommunityAssessmentData } from '@/types/entities/clients/assessment';
import { AddOnsSelector } from '@/components/addons/AddOnsSelector';
import { MONTANA_ADDONS_CATALOG } from '@/data/addons/catalog.montana';
import { useToast } from '@/components/ui/use-toast';

interface AddOnsConfirmationProps {
  data: Partial<CommunityAssessmentData>;
  onUpdate: (update: Partial<CommunityAssessmentData>) => void;
  tier: 'silver' | 'gold' | 'custom';
}

export const Step_8_AddOnsConfirmation: React.FC<AddOnsConfirmationProps> = ({
  data,
  onUpdate,
  tier,
}) => {
  const [selected, setSelected] = useState<string[]>(data.selectedAddOns || []);
  const { toast } = useToast();

  useEffect(() => {
    setSelected(data.selectedAddOns || []);
  }, [data.selectedAddOns]);

  const visibleAddOns = useMemo(() => {
    return MONTANA_ADDONS_CATALOG.filter((a) => a.applicableTiers.includes(tier));
  }, [tier]);

  const handleSave = () => {
    onUpdate({ selectedAddOns: selected });
    toast({
      title: 'Add-ons saved',
      description: selected.length
        ? `${selected.length} add-on${selected.length === 1 ? '' : 's'} saved.`
        : 'No add-ons selected.',
    });
  };

  return (
    <div className="space-y-6">
      <p className="text-gray-700 text-sm">
        Review and confirm any optional add-ons. Quote-based items are scoped separately and can be
        adjusted later.
      </p>
      <AddOnsSelector
        items={visibleAddOns}
        selected={selected}
        onChange={setSelected}
        title="Confirm Add-ons"
        subtitle="You can adjust these during your discovery call as needed."
      />
      <div className="flex justify-end">
        <Button onClick={handleSave}>Save Add-ons</Button>
      </div>
    </div>
  );
};
